import { SET_DEFAULT_STATE } from './constants';

/**
 * Fire when user enters or leaves hardware flow
 */
export function setDefaultState (salesChannel, subscriptionId, gigakombi, gigakombiToken: string) {
    return {
        type: SET_DEFAULT_STATE,
        salesChannel,
        subscriptionId,
        gigakombi,
        gigakombiToken,
    };
}
